/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { environment } from '@app/environments/environment';

export class PortfolioProjectFormsEnabledHelper {
  static isPortfolioProjectFormsEnabled(): boolean {
    return environment.env === 'dev' || window.location.hostname.includes('at25.potential.ly');
  }
}
